const Stepper = ({ steps, currentStep }) => {
  return (
    <div className="flex justify-between px-4 mb-8 max-w-md mx-auto">
      {steps.map((step, index) => (
        <div key={step} className="flex flex-col items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center ${
              index <= currentStep
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}
          >
            {index + 1}
          </div>
          <span className="text-xs mt-1 max-w-[100px] text-center">{step}</span>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
